import { Component, inject } from "@angular/core";
import { SharedService } from "../../core/services/shared/shared.service";

@Component({
  selector: "app-coming-soon-page",
  templateUrl: "./coming-soon-page.component.html",
  styleUrls: ["./coming-soon-page.component.css"]
})
export class ComingSoonPageComponent {
  sharedService = inject(SharedService);

  constructor() {}
}
